import { Document, DocumentSource, IDocumentOptions } from "firestorter";

import { User } from "../auth";
import Store from "../index";

interface Data {
  createdBy: string;
}

class StoreDocument<T extends object> extends Document<T> {
  readonly store: Store;
  protected _createdBy?: User;

  constructor(source: DocumentSource, options: IDocumentOptions, store: Store) {
    super(source, options);
    this.store = store;
  }

  get createdBy() {
    const data = this.data as Data;
    if (data.createdBy !== this._createdBy?.id) {
      this._createdBy =
        data.createdBy !== "*"
          ? new User(`user/${data.createdBy}`, {}, this.store)
          : undefined;
    }
    return this._createdBy;
  }
}

export default StoreDocument;
